import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { productListStyles } from "@dana/Overrides/Widgets/MyListsDetails/MyListsDetailsProductList";
import { productListLineStyles } from "@dana/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { GridOffset } from "@insite/mobius/GridContainer/GridContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";


productListStyles.container = mergeToNew(productListStyles.container, {
    css: css`
        @media print {
            &:first-child {
                margin-top: 8px;
            }
        }
    `
});
productListStyles.lineGridItem = mergeToNew(productListStyles.lineGridItem, {
    css: css`
        @media print {
            padding: 8px 0;
            [data-test-selector="productNumberLink"],
            
            span[class*="TypographyStyle"] {
                font-size: ${fontSizes.xSmall};
                margin: 0;
            }
            .wishlist-line-quantity-grid-item {
                [class*="FormFieldStyle"] {
                    display: none;
                }
            }
        }
    `
});
